<template>
  <div v-if="href" class="snat-ext-hub" role="region" aria-label="Herramienta SNAT centralizada">
    <a :href="href" target="_blank" rel="noopener noreferrer" class="snat-ext-hub__link">
      <i class="pi pi-external-link" aria-hidden="true" />
      <span>{{ label }}</span>
    </a>
    <span class="snat-ext-hub__hint">Registro centralizado (cliente / proyecto). La herramienta embebida sigue disponible si está activada.</span>
  </div>
</template>

<script>
import { snatExternalHubUrl, snatExternalHubLabel } from '@/utils/snatClientToolsRuntime';

export default {
  name: 'SnatExternalClientToolsEntry',
  computed: {
    href() {
      return snatExternalHubUrl();
    },
    label() {
      return snatExternalHubLabel();
    },
  },
};
</script>

<style scoped>
.snat-ext-hub {
  position: fixed;
  z-index: 10039;
  right: 0.75rem;
  bottom: calc(0.75rem + env(safe-area-inset-bottom, 0px));
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.3rem;
  max-width: min(300px, calc(100vw - 1.5rem));
  pointer-events: none;
}

.snat-ext-hub > * {
  pointer-events: auto;
}

.snat-ext-hub__link {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.5rem 0.95rem;
  border-radius: 999px;
  font-size: 0.8125rem;
  font-weight: 700;
  text-decoration: none;
  color: #f0f9ff;
  background: linear-gradient(165deg, #0369a1 0%, #0c4a6e 100%);
  border: 1px solid #082f49;
  box-shadow: 0 6px 22px rgba(2, 48, 71, 0.38);
}

.snat-ext-hub__link:hover {
  filter: brightness(1.07);
}

.snat-ext-hub__hint {
  font-size: 0.65rem;
  color: #0c2d48;
  text-align: right;
  line-height: 1.25;
  background: linear-gradient(180deg, #e0f2fe 0%, #bae6fd 100%);
  padding: 0.35rem 0.55rem;
  border-radius: 8px;
  border: 1px solid #38bdf8;
}
</style>
